import Projects from '../data/Projects'
import { useParams } from 'react-router-dom'
import { useState, useEffect } from 'react'
import classes from './style/projectDetails.module.css'
import LoadingTwo from '../components/UI/LoadingTwo'
import Button from '../components/Button'
const ProjectDetails = () => {
    let { id } = useParams();
    const [spinner, setSpinner] = useState(true)
    const [product, setProduct] = useState(Projects[id])

    useEffect(() => {
        setProduct(Projects[id]);
        setTimeout(() => {
            setSpinner(false)
        } , 3000);
    }, [id])

    return (
        <>
            {spinner ? <LoadingTwo /> :
                <div className={classes.Container}>
                    <h1 className='title'>

                        {
                            product.name
                        }
                    </h1>
                    <p className='subTitle color2'><span className='subTitleBefore'> /* </span> {product.subTitle} <span className='subTitleAfter'> */ </span></p>

                    <Button />

                    <div className={classes.projectContainer}>

                        <div className={classes.imgsConatiner}>
                            <img src={product.img} alt="project" />
                        </div>


                        <div className={classes.describtionContiner}>
                            <h3>
                                {
                                    product.describe
                                }
                            </h3>

                            <div className={classes.btn}>
                                <a href={product.link} target="_blank" >preview</a>
                            </div>
                        </div>

                    </div>


                    <div className={classes.moreDetails}>
                        <h2>Key Contributions</h2>
                        <ul>
                            {

                                product.key.map((item, index) => <li key={index}> {item}</li>)

                            }
                        </ul>
                        <h2>Outcome</h2>
                        <p>{product.outcome}</p>
                    </div>

                </div>

            }

        </>
    )
}

export default ProjectDetails
